import { intersection, groupBy } from 'lodash';
import { Device, ZoneMetricId, ZoneMetricCategory } from '@contentsquare/global-constants';
/**
 * Use this array to store the metrics that are under development or rollout phase
 * You will need to manually add them in the relevant arrays in function of the feature flag value
 * Once the feature flag is cleaned, move those metrics in the global ZONE_METRICS array bellow
 */
export const ZONE_METRICS_UNDER_DEVELOPMENT = [];
// 29 metrics in total
export const ZONE_METRICS = [
    {
        id: ZoneMetricId.TotalRevenueAfterClick,
        category: ZoneMetricCategory.ROI,
        format: 'csCurrency',
        devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet],
    },
    {
        id: ZoneMetricId.AverageRevenueAfterClick,
        category: ZoneMetricCategory.ROI,
        format: 'csCurrency',
        devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet],
    },
    {
        id: ZoneMetricId.AvgConversionAfterClick,
        category: ZoneMetricCategory.Performance,
        withGoals: true,
        format: 'csRate',
        devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet],
    },
    {
        id: ZoneMetricId.AvgConversionAfterHover,
        category: ZoneMetricCategory.Performance,
        withGoals: true,
        format: 'csRate',
        devices: [Device.All, Device.Desktop],
    },
    {
        id: ZoneMetricId.AvgTransactionAfterClick,
        category: ZoneMetricCategory.ROI,
        format: 'csRate',
        devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet],
    },
    {
        id: ZoneMetricId.AvgTransactionAfterHover,
        category: ZoneMetricCategory.ROI,
        format: 'csRate',
        devices: [Device.All, Device.Desktop],
    },
    {
        id: ZoneMetricId.ClickRate,
        category: ZoneMetricCategory.Attractiveness,
        format: 'csRate',
        devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet],
    },
    {
        id: ZoneMetricId.ClickRateSession,
        category: ZoneMetricCategory.Attractiveness,
        format: 'csRate',
        devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet],
    },
    {
        id: ZoneMetricId.ClickDistribution,
        category: ZoneMetricCategory.Attractiveness,
        format: 'csRate',
        devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet],
    },
    {
        id: ZoneMetricId.TimeBeforeFirstClick,
        category: ZoneMetricCategory.Attractiveness,
        format: 'csSeconds',
        devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet],
    },
    {
        id: ZoneMetricId.HoverRate,
        category: ZoneMetricCategory.Interaction,
        format: 'csRate',
        devices: [Device.All, Device.Desktop],
    },
    {
        id: ZoneMetricId.EngagementRate,
        category: ZoneMetricCategory.Interaction,
        format: 'csRate',
        devices: [Device.Desktop],
    },
    {
        id: ZoneMetricId.Hesitation,
        category: ZoneMetricCategory.Interaction,
        format: 'csSeconds',
        devices: [Device.All, Device.Desktop],
    },
    {
        id: ZoneMetricId.HoverTime,
        category: ZoneMetricCategory.Interaction,
        format: 'csSeconds',
        devices: [Device.All, Device.Desktop],
    },
    {
        id: ZoneMetricId.ClickRepetition,
        category: ZoneMetricCategory.Interaction,
        format: 'csNumber',
        devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet],
    },
    {
        id: ZoneMetricId.ExposureRate,
        category: ZoneMetricCategory.Heatmap,
        format: 'csRate',
        devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet],
    },
    {
        id: ZoneMetricId.ExposureTime,
        category: ZoneMetricCategory.Heatmap,
        format: 'csSeconds',
        devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet],
    },
    {
        id: ZoneMetricId.AttractivenessRate,
        category: ZoneMetricCategory.Interaction,
        format: 'csRate',
        devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet],
    },
    {
        // used to calculate ClickDistribution
        // but also need to appear in the metric list
        id: ZoneMetricId.TotalClicks,
        category: ZoneMetricCategory.Attractiveness,
        format: 'csInteger',
        devices: [Device.All, Device.Desktop, Device.Mobile, Device.Tablet],
    },
    {
        id: ZoneMetricId.SwipeRateWeb,
        category: ZoneMetricCategory.Interaction,
        format: 'csRate',
        devices: [Device.Mobile, Device.Tablet],
    },
    {
        id: ZoneMetricId.TotalRevenueAfterTap,
        category: ZoneMetricCategory.ROI,
        format: 'csCurrency',
        devices: [Device.MobileSdk, Device.TabletSdk],
    },
    {
        id: ZoneMetricId.AverageRevenueAfterTap,
        category: ZoneMetricCategory.ROI,
        format: 'csCurrency',
        devices: [Device.MobileSdk, Device.TabletSdk],
    },
    {
        id: ZoneMetricId.TransactionAfterTap,
        category: ZoneMetricCategory.ROI,
        format: 'csRate',
        devices: [Device.MobileSdk, Device.TabletSdk],
    },
    {
        id: ZoneMetricId.ConversionAfterTap,
        category: ZoneMetricCategory.Performance,
        withGoals: true,
        format: 'csRate',
        devices: [Device.MobileSdk, Device.TabletSdk],
    },
    {
        id: ZoneMetricId.ConversionRatePerSwipe,
        category: ZoneMetricCategory.Performance,
        withGoals: true,
        format: 'csRate',
        devices: [Device.MobileSdk, Device.TabletSdk],
    },
    {
        id: ZoneMetricId.TapRate,
        category: ZoneMetricCategory.Attractiveness,
        format: 'csRate',
        devices: [Device.MobileSdk, Device.TabletSdk],
    },
    {
        id: ZoneMetricId.TapRateSession,
        category: ZoneMetricCategory.Attractiveness,
        format: 'csRate',
        devices: [Device.MobileSdk, Device.TabletSdk],
    },
    {
        id: ZoneMetricId.TapRecurrence,
        category: ZoneMetricCategory.Interaction,
        format: 'csNumber',
        devices: [Device.MobileSdk, Device.TabletSdk],
    },
    {
        // used to calculate TapDistribution, thus will not appears in metric select list
        id: ZoneMetricId.TapCount,
        category: ZoneMetricCategory.Attractiveness,
        format: 'csInteger',
        devices: [Device.MobileSdk, Device.TabletSdk],
    },
    {
        id: ZoneMetricId.TapDistribution,
        category: ZoneMetricCategory.Attractiveness,
        format: 'csRate',
        devices: [Device.MobileSdk, Device.TabletSdk],
    },
    {
        id: ZoneMetricId.TimeBeforeFirstTap,
        category: ZoneMetricCategory.Attractiveness,
        format: 'csSeconds',
        devices: [Device.MobileSdk, Device.TabletSdk],
    },
    {
        id: ZoneMetricId.SwipeRate,
        category: ZoneMetricCategory.Interaction,
        format: 'csRate',
        devices: [Device.MobileSdk, Device.TabletSdk],
    },
    {
        id: ZoneMetricId.SwipeRecurrence,
        category: ZoneMetricCategory.Interaction,
        format: 'csNumber',
        devices: [Device.MobileSdk, Device.TabletSdk],
    },
];
export class MetricsListBuilder {
    constructor() {
        this.filterByProjectType = (isSDK) => this.filterMetric((metric) => isSDK
            ? intersection([Device.MobileSdk, Device.TabletSdk], metric.devices).length > 0
            : intersection([Device.All, Device.Desktop, Device.Mobile, Device.Tablet], metric.devices).length > 0);
        this.filterById = (id) => this.filterMetric((metric) => metric.id === id);
        this.filterByDevice = (devices) => this.filterMetric((metric) => intersection(devices, metric.devices).length > 0);
        this.applyCustomFilterFn = (filterFn) => this.filterMetric(filterFn);
    }
    filterMetric(precondition) {
        return (metrics) => metrics.filter(precondition);
    }
    getFilterFn(filterType) {
        switch (filterType) {
            case 'isSDK':
                return this.filterByProjectType;
            case 'metricId':
                return this.filterById;
            case 'devices':
                return this.filterByDevice;
            case 'customFilter':
                return this.applyCustomFilterFn;
            default:
                return () => (metrics) => metrics;
        }
    }
    composeFilters(filters) {
        const filtersFn = Object.entries(filters).map(([type, value]) => this.getFilterFn(type)(value));
        return filtersFn.reduce((fn, filterFn) => {
            return (metrics) => fn(filterFn(metrics));
        }, (metrics) => metrics);
    }
    getMetrics(filters = {}) {
        const filterFn = this.composeFilters(filters);
        return filterFn(ZONE_METRICS);
    }
    getCategorizedMetrics(filters = {}) {
        const metricsWithCategory = this.getMetrics(filters).filter((metric) => !!metric.category);
        return groupBy(metricsWithCategory, 'category');
    }
}
//# sourceMappingURL=zone-metrics.js.map